t = require('app/scripts/views/internal/teacup-with-helpers')('popover_add_list')

module.exports = t.renderable ({ tooManyTotalLists, tooManyOpenLists }) ->
  if tooManyTotalLists
    t.p ->
      t.format 'you-have-too-many-lists-on-this-board'
    return

  if tooManyOpenLists
    t.p ->
      t.format 'you-have-too-many-open-lists-on-this-board'
    return

  t.form ->
    t.div '.form-grid', ->

      t.div '.form-grid-child.form-grid-child-threequarters', ->
        t.label { for: 'list-name' }, ->
          t.format 'name'
        t.input '.js-list-name.js-autofocus', { type: 'text', id: 'list-name', value: t.l('default-list-name'), style: 'margin-bottom: 0;' }

      t.div '.form-grid-child.form-grid-child-quarter', ->
        t.div '.button-link.setting', { style: 'margin-top: 4px;' }, ->
          t.span '.label', ->
            t.format 'position'
          t.span '.value.js-pos-value'
          t.label ->
            t.format 'position'
          t.select '.js-select-list-pos'

    t.input '.primary.wide.js-add-list', { type: 'submit', value: t.l('add') }

